import * as yup from 'yup';

export const DATE_OF_LOSS_REQUIRED_MESSAGE = 'Date of Loss is required';
export const TIME_ZONE_REQUIRED_MESSAGE = 'Time Zone is required';

/**
 * FNOL Request Date of Loss when the claim lookup did not provide one. The
 * picker writes an ISO string while a looked-up value is a Date, so both are
 * accepted; an empty or unparseable value fails with the required message.
 */
export const buildEditableDateOfLossSchema = (): yup.AnySchema =>
  yup
    .date()
    .nullable()
    .typeError(DATE_OF_LOSS_REQUIRED_MESSAGE)
    .required(DATE_OF_LOSS_REQUIRED_MESSAGE);

/**
 * FNOL Request Time Zone when the Date of Loss is typed by hand: the typed
 * wall-clock time is converted from this zone at submit, so without it the
 * calendar date could shift.
 */
export const buildEditableDateOfLossTimeZoneSchema = (): yup.AnySchema =>
  yup.string().nullable().required(TIME_ZONE_REQUIRED_MESSAGE);

/** Claim Information Date of Loss: the ingress value is always an ISO string. */
export const buildIngressDateOfLossSchema = (): yup.AnySchema =>
  yup.string().required(DATE_OF_LOSS_REQUIRED_MESSAGE);
